<template>
	<div class="modal-wrapper" @click="close">
		<div class="modal-container modal-container-full" @click.stop.prevent="() => false">
			<div class="modal-header">
				<div class="row">
					<div class="col-xs-12 col-lg-12">
						ARQUIVO DE LOGS DO SISTEMA: {{ current.filename }}
						<button class="modal-close" @click="close"><i class="fa fa-times"></i></button>
					</div>
				</div>
			</div>
			<div class="modal-body modal-body-full">
				<div v-if="loading" class="row">
                    <div class="col-xs-12 col-lg-12">
                        <div class="loading loading-full">
                            <span class="loading-icon"><i class="fa fa-circle-notch fa-spin"></i></span>
                            <span class="loading-text">{{ loading_text }}</span>
                        </div>
                    </div>
                </div>
				<div v-else class="row">
					<div class="col-xs-12 col-lg-12">
						<div class="container-form">
							<div class="row">
								<div class="col-xs-12 col-lg-2 form-input">
									<FormInput v-model="search" label="Pesquisar no arquivo" type="text" icon="fa-search" tooltip="Informe uma palavra-chave para pesquisar nos registros do arquivo" ref="search" />
								</div>
								<div v-if="false" class="col-xs-12 col-lg-2 form-input">
									<FormSelect v-model="per_page" label="Quantidade de registros buscados por vez" :options="options.per_page" icon="fa-download" tooltip="Selecione a quantidade de registros que devem ser buscados por vez" ref="per_page" />
								</div>
								<div class="col-xs-12 col-lg-2 form-button">
									<button class="button-modify-text" @click="font_size--" title="Diminuir tamanho do texto"><i class="fas fa-font"></i><i class="fas fa-minus"></i></button>
									<button class="button-modify-text" @click="font_size++" title="Aumentar tamanho do texto"><i class="fas fa-font"></i><i class="fas fa-plus"></i></button>
								</div>
								<div class="col-xs-12 col-lg-offset-6 col-lg-2 form-text">
									Mostrando {{ searchedList().length }} registros de {{ total }}
								</div>
							</div>
						</div>
					</div>
					<div class="col-xs-12 col-lg-12">
						<div class="container-log" :style="'font-size: ' + font_size + 'px'">
							<table v-if="searchedList().length > 0" class="table-registers">
								<tbody>
									<tr v-for="(line, index) in searchedList()" :key="'log_' + index">
										<td class="table-index">{{ index + 1 }}</td>
										<td class="table-text">{{ line }}</td>
									</tr>
									<tr>
										<td colspan="2">
											<button v-if="searchedList().length < total" :disabled="loading_button" class="button-update" @click="getRegistriesFromFile(true)">
												<i v-if="loading_button" class="fas fa-circle-notch fa-spin"></i> 
												<i v-else class="fas fa-angle-down"></i> 
												BUSCAR MAIS REGISTROS
											</button>
										</td>
									</tr>
								</tbody>
							</table>
							<div v-else class="col-xs-12 text-center">
								<small><i>Não foram encontrados registros de logs nesse arquivo.</i></small>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Api from "@/lib/Api";

import FormInput from "@/components/FormInput";
import FormSelect from "@/components/FormSelect";

export default {
	name: "AdminModalLog",

	props: {
		current: {
			type: Object,
			required: true,
		},
	},

	components: {
        FormInput,
		FormSelect,
	},

	beforeMount:  async function() {
		await this.getRegistriesFromFile();
	},

	data: function() {
		return {
			loading: false,
			loading_button: false,
			loading_text: "Carregando arquivo",
			search: "",
			font_size: 16,
			file: [],
			page: 0,
			per_page: 50,
			total: 0,
			options: {
				per_page: {
					25: "25",
					50: "50",
					100: "100",
				}
			},
		};
	},

	methods: {
		/**
		 * Obtém os registros de logs de um arquivo
		 */
		getRegistriesFromFile: async function(get_more = false) {
			// Se for buscando mais registros, atualiza a página atual
			if (get_more) {
				this.page += 1;
			}

			// Inicia o objeto de envio
			let form = {
				filename: this.current.filename,
				page: this.page,
				per_page: this.per_page,
			};
			
			// Inicia o loading
			let result = null;
			if (get_more) {
				this.loading_button = true;
			} else {
				this.loading = true;
			}

			// Busca os regstros
			try {
				result = await Api.post("log/get-file", form, "admin");
			} catch(ex) {
				console.log(ex);
				this.$notification.error("Não é possível obter as informações do arquivo.");
				if (get_more) {
					this.loading_button = false;
				} else {
					this.loading = false;
					this.close();
				}
				return;
			}
			
			// Verifica o resultado
			if (result) {
				if (result.error) {
					if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
						this.$notification.error(result.data);
						if (get_more) {
							this.loading_button = false;
						} else {
							this.loading = false;
							this.close();
						}
						return;
					}
				} else {
					this.total = result.total;
					if (get_more) {
						this.file = this.file.concat(result.data);
						this.loading_button = false;
					} else {
						this.file = result.data;
						this.loading = false;
					}
					return;
				}
			} else {
				this.$notification.error("Não foi possível obter todas as informações do arquivo.");
				if (get_more) {
					this.loading_button = false;
				} else {
					this.loading = false;
					this.close();
				}
				return;
			}
		},

		// Busca e filtra a lista
        searchedList: function() {
            if(this.search) {
                let exp = new RegExp(this.search.trim(), 'i');
                let searched_list = this.file.filter(register => exp.test(register));
				return searched_list;
            } else {
				return this.file;
            }
        },

		// Fecha o modal
		close: function() {
			this.$emit("close");
		},
	}
}
</script>

<style scoped>
.modal-wrapper {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background: #00000044;
	z-index: 3;
}

.modal-container {
	position: absolute;
	margin: auto;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: #fff;
	border-radius: 4px;
}

.modal-container-full {
	width: calc(100vw - 30px);
	height: calc(100vh - 30px);
}

.modal-header {
	position: relative;
	border-bottom: 1px solid #ddd;
	min-height: 50px;
	padding: 15px;
	font-weight: bold;
	background: #f9f9f9;
	border-top-left-radius: 4px;
	border-top-right-radius: 4px;
}

.modal-close {
	position: absolute;
	top: 12px;
	right: 15px;
	font-size: 20px;
	background: none;
	border: none;
	color: #999;
}

.modal-body {
	padding: 0px 0px 15px;
	width: 100%;
	overflow-y: hidden;
	overflow-x: hidden;
}

.modal-body-full {
    height: calc(100vh - 80px);
}

.loading {
    position: absolute;
    top: 50px;
    left: 0;
    background: #fff;
    color: #222;
    text-align: center;
    font-family: Verdana;
    z-index: 10;
}

.loading-full {
    width: calc(100vw - 30px);
	height: calc(100vh - 80px);
    line-height: calc(100vh - 80px);
}

.loading-icon {
    border-top: 1px solid #ddd;
    border-left: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    background-color: #f5f5f5;
    padding: 20px 5px 20px 20px;
    font-size: 20px;
    z-index: 10;
}

.loading-text {
    border-top: 1px solid #ddd;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    background-color: #f5f5f5;
    padding: 20px 20px 20px 5px;
    font-size: 20px;
    z-index: 10;
}

.form-input {
    display: grid;
    align-content: center;
}

.form-button {
    display: inline;
}

.form-text {
    text-align: right;
	line-height: 90px;
}

.button-modify-text {
	margin-top: 25px;
	margin-left: 15px;
	margin-bottom: 25px;
	width: 40px;
	height: 40px;
	border: none;
	border-radius: 4px;
	background: #666;
	color: #fff;
	font-weight: bold;
}

.button-update {
	margin-top: 15px;
	height: 40px;
	border: none;
	border-radius: 4px;
	background: #666;
	color: #fff;
	font-weight: bold;
}

.container-form {
	width: 100%;
	padding: 0px 15px;
	background-color: #fff;
}

.container-log {
	height: calc(100vh - 195px);
	width: 100%;
	padding: 15px;
	background-color: #222;
	color: #fff;
	overflow-y: auto;
	overflow-x: auto;
}

.has-focus .input-label {
	color: #fff;
}

.input-element {
	border-bottom: 1px solid #fff;
}

.table-registers > tbody > tr > td {
	text-align: left;
	vertical-align: top;
}

.table-index {
	padding-right: 10px;
	border-right: 1px #fff solid;
}

.table-text {
	padding-left: 10px;
	padding-bottom: 10px;
}
</style>